const BRIDGE_CATEGORY = 'bridge'

export const BRIDGE_EVENTS = {
  OPEN_BRIDGE: {
    action: 'Open bridge',
    category: BRIDGE_CATEGORY,
  },
}

export enum BRIDGE_LABELS {
  sidebar = 'sidebar',
}
